var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fsxa-app',{attrs:{"devMode":_vm.devMode,"useErrorBoundaryWrapper":_vm.useErrorBoundaryWrapper,"currentPath":this.$router.currentRoute.path,"defaultLocale":"en_US","components":_vm.components,"handleRouteChange":_vm.handleRouteChange,"fsTppVersion":"cloud-qa","customSnapHooks":_vm.customSnapHooks}})
}
var staticRenderFns = []

export { render, staticRenderFns }